import { useMissionsUrl } from '@/features/missions/context/MissionsUrlProvider'
import { Button, Text } from '@/ui-kit'
import { Trans } from '@lingui/react/macro'
import { Clock, LayoutGrid } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

export function NoCapacityStep() {
  const navigate = useNavigate()
  const { missionsUrl } = useMissionsUrl()

  return (
    <div className="m-auto mt-4 flex max-w-[800px] flex-col items-center gap-4">
      <div className="flex w-full flex-col items-center gap-6 rounded-2xl border border-solid border-gray-100 px-10 py-12 text-center">
        <div className="bg-black-to-white flex size-24 items-center justify-center rounded-full">
          <div className="text-gray-80 flex size-20 items-center justify-center rounded-full bg-gray-100">
            <Clock className="size-10" />
          </div>
        </div>

        <div className="flex flex-col items-center gap-2">
          <Text type="h5" className="text-gray-70">
            <Trans>No tasks available right now</Trans>
          </Text>
          <Text type="body2-regular" className="text-gray-80 max-w-[460px]">
            <Trans>
              There are no open conversation slots at the moment. Please check back later — availability changes
              frequently.
            </Trans>
          </Text>
        </div>

        <div className="flex flex-col items-center gap-3 pt-2">
          <Text type="body3-regular" className="text-gray-80">
            <Trans>In the meantime, explore other missions</Trans>
          </Text>
          <Button variant="default" size="small" onClick={() => navigate(missionsUrl)} className="gap-2">
            <LayoutGrid className="size-4" />
            <Trans>Browse missions</Trans>
          </Button>
        </div>
      </div>
    </div>
  )
}
